<iframe
  width="100%"
  height="700"
  [src]="_billData.bill.proofOfPayment | safe"></iframe>
